<template>
  <script type="application/ld+json">
    {{
      {
        "@context": "https://schema.org/",
        "@type": "Review",
        "itemReviewed": {
          "@type": "Product",
          "name": productName,
          "description": productDescription
        },
        "author": {
          "@type": "Person",
          "name": author
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": ratingValue,
          "bestRating": BEST_REVIEW_RATING,
          "worstRating": WORST_REVIEW_RATING
        },
        "reviewBody": reviewBody
      }
    }}
  </script>
</template>

<script>
/*
 * Based on https://developers.google.com/search/docs/data-types/review-snippet
 */
import { BEST_REVIEW_RATING, WORST_REVIEW_RATING } from '@/stores/product'

export default {
  name: 'SeoReviewRating',

  props: {
    productName: {
      type: String,
      required: true,
    },
    productDescription: {
      type: String,
      required: true,
    },
    author: {
      type: String,
      required: true,
    },
    ratingValue: {
      type: Number,
      required: true,
    },
    reviewBody: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      BEST_REVIEW_RATING,
      WORST_REVIEW_RATING,
    }
  },
}
</script>
